/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import StarIcon from '@material-ui/icons/Star';

export const Star = ({ className }) => {
  return (
    <StarIcon
      className={className}
      css={css`
        color: #fdce02;
        width: 13px;
        height: 13px;
      `}
    />
  );
};
